import { useEffect } from "react";
import type { Matomo, TrackingParams } from "../types/tracking";
import { getTrackingFns } from "../utils/tracking";

export const useTracking = (config: TrackingParams) => {
	const { ignoredUrls, matomoInstance, currentPath } = config;

	useEffect(() => {
		if (!matomoInstance) return;

		const { trackClick, trackAllContentImpressions } = getTrackingFns(matomoInstance);

		try {
			matomoInstance?.FormAnalytics?.enableFormAnalytics();
			matomoInstance?.HeatmapSessionRecording?.disable();
			trackAllContentImpressions();
		} catch (e) {
			// oxlint-disable-next-line no-console
			console.error(e);
		}

		// for keypress events
		window.addEventListener("keyup", (e) => {
			if (e.key === " " || e.key === "Enter") trackClick(e);
		});
		// for mouse click or touch events:
		window.addEventListener("pointerup", trackClick);

		return () => {
			window.addEventListener("keyup", trackClick);
			window.removeEventListener("pointerup", trackClick);
		};
	}, []);

	useEffect(() => {
		const { trackPageView } = getTrackingFns(matomoInstance);

		if (ignoredUrls?.includes(currentPath)) return;

		// this effect runs twice on page load in dev mode:
		trackPageView(currentPath);
	}, [currentPath]);
};

export const useTrackImpressions = (matomoInstance?: Matomo) => {
	const { trackAllContentImpressions } = getTrackingFns(matomoInstance);

	useEffect(() => {
		trackAllContentImpressions();
	}, []);
};
